import React from "react";
import { IAgentDetail } from "@vahak/core/dist/custom-types/common-preloads";
import { useToggleModalWithLocalState } from "@vahak/core-ui/dist/hooks/useToggleModalWithLocalState";
import AgentDetailsPopup from "./AgentDetailsPopup";
import { AutoAssignInfo, IAssignedAgentDetail } from "../../../services/load/useGetLoadMarketV2/type";
import AssignedCsPopup, { AssignedCsPayload } from "./AssignedCsPopup";
import Chip from "@vahak/core-ui/dist/components/Chip";
import { useCsDashboard } from "@vahak/core/dist/hooks";
import Typography from "@vahak/core-ui/dist/components/Typography";
import Flex from "@vahak/core-ui/dist/layout/Flex";
import UnassigmentInfo from "./UnassigmentInfo";

interface AgentBadgeBaseProps {
    type: "tso" | "cs";
}

interface TsoAgentBadgeProps extends AgentBadgeBaseProps {
    type: "tso";
    data?: IAgentDetail;
}
export interface CsAgentBadgeProps extends AgentBadgeBaseProps {
    type: "cs";
    data?: IAssignedAgentDetail;
    payload?: AssignedCsPayload;
    allowAssignment?: boolean;
    onSuccess?: () => void;
    autoAssignmentInfo?: AutoAssignInfo;
    label?: string;
}

type AgentBadgeProps = TsoAgentBadgeProps | CsAgentBadgeProps;

const AgentBadge = (props: AgentBadgeProps) => {
    const { type, data } = props;
    const { isModalOpen, toggleModal } = useToggleModalWithLocalState(false);
    const autoAssigmentInfoPopup = useToggleModalWithLocalState(false);
    const { isTsoV2 } = useCsDashboard();
    switch (type) {
        case "cs": {
            const onClick = props.allowAssignment ? toggleModal : undefined;
            return (
                <Flex gap={4} alignItems="center" style={{}}>
                    {props?.label}
                    {data?.name ? (
                        <Chip color="blue" size="auto" outlined radius={12} onClick={onClick}>
                            {data.name}
                        </Chip>
                    ) : (
                        <Chip color="grey" size="auto" outlined radius={12} onClick={onClick}>
                            Un-assigned
                        </Chip>
                    )}

                    <UnassigmentInfo
                        data={props?.autoAssignmentInfo}
                        isOpen={autoAssigmentInfoPopup?.isModalOpen}
                        onToggle={autoAssigmentInfoPopup?.toggleModal}
                    />

                    {isModalOpen && props.onSuccess && (
                        <AssignedCsPopup
                            data={data}
                            isOpen={isModalOpen}
                            onToggle={toggleModal}
                            payload={props.payload}
                            onSuccess={props.onSuccess}
                        />
                    )}
                </Flex>
            );
        }
        case "tso": {
            if (isTsoV2) {
                return null;
            }
            return data?.agent_name ? (
                <>
                    <Chip color="green" size="auto" outlined radius={12} onClick={toggleModal}>
                        {data?.agent_name}
                    </Chip>

                    {isModalOpen && <AgentDetailsPopup data={data} isOpen={isModalOpen} onToggle={toggleModal} />}
                </>
            ) : (
                <Chip color="grey" size="auto" outlined radius={12}>
                    Un-tagged
                </Chip>
            );
        }
    }
};

export default AgentBadge;

export const AgentBadgeWithLabel = (
    props: AgentBadgeProps & {
        label: string;
    }
) => {
    const { label, ...restProps } = props;
    return (
        <>
            <Typography size="s">
                {label ? label + ": " : ""}
                <AgentBadge {...restProps} />
            </Typography>
        </>
    );
};
